import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const _authService = inject(AuthService);

  if (!req.url.includes('login')) {
      const userData: any = localStorage.getItem('user');
      const accessToken = JSON.parse(userData)?.accessToken;

      req = req.clone({
          setHeaders: {
              Authorization: `Bearer ${accessToken}`
          }
      })
  }

  return next(req).pipe(catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        _authService.logout();
      }

      return throwError(() => error);
  }));
}

